// extracted by mini-css-extract-plugin
export var grayCircle = "_dz-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_dz-1";
export var selectedCircle = "_dz-2";
export var shippingOptionImage = "_dz-3";
export var shippingOptionWidgetPreview = "_dz-4";